import { Dispatch } from "redux";
import Config from "../../../../config/config";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import ProductTypesUrl from "../../../../constants/ProductTypesUrl";
import Segments from "../../../../constants/Segments";
import { Purchases } from '../../../../constants/Purchases';
import { IBasketOrderItem } from "../../../../entities/manhattan/order/types";
import { apiRequest } from "../../api/actions";
import { createErrorNotification } from "../../notification/actions";
import { INotification } from "../../notification/types";
import { redirectToAction } from "../../redirection/actions";
import { AppState } from "../../rootReducers";
import { setError } from "../../ui/actions";
import { updateFullItemLoaderStatusAction } from "./actions";
import { RemoveOrderItemFromBasketPayload } from "./types";
import { getFlatStructureOfBasketItems } from "../../../../utilites/order";

abstract class IChooseDifferentAccessoryMiddleware {

  public static callAPI: (next: Dispatch, payload: any) => void;
  public static handleAPISuccess: (state: AppState, next: Dispatch) => void;
  public static handleAPIError: (state: AppState, next: Dispatch, payload: any) => void;

}

export default class ChooseDifferentAccessoryMiddleware implements IChooseDifferentAccessoryMiddleware {

  public static callAPI(next: Dispatch, payload: RemoveOrderItemFromBasketPayload): void {
    const { itemId } = payload;

    next(apiRequest(
      null,
      'DELETE', `${ApiUrls.ORDER_ITEM}/${itemId}`,
      null,
      null,
      MiddlewareEntities.ORDER.PREPARE_BASKET_ITEM_FOR_REPLACEMENT,
      {}),
    );

    next(updateFullItemLoaderStatusAction({
      itemId,
      status: true
    }));
  }

  public static handleAPISuccess(state: AppState, next: Dispatch): void {
    const language = state.language.language;
    const purchase = state.productData.productData.purchase;
    const purchaseType = purchase === Purchases.COSMOS ? Purchases.COSMOS : Purchases.SUBSIDY;

    next(setError(false, MiddlewareEntities.ORDER.PREPARE_BASKET_ITEM_FOR_REPLACEMENT));
    next(redirectToAction(`${Config.prefixUrl}/${language}/${Segments[language].PRIVATE_SEGMENT}/${ProductTypesUrl[language].accessory}/?purchase=${purchaseType}`));
  }

  public static handleAPIError(state: AppState, next: Dispatch, payload: any): void {
    next(setError(true, MiddlewareEntities.ORDER.PREPARE_BASKET_ITEM_FOR_REPLACEMENT));
    next(createErrorNotification(payload.data as INotification, MiddlewareEntities.ORDER.PREPARE_BASKET_ITEM_FOR_REPLACEMENT));

    const basketItems = getFlatStructureOfBasketItems(state.manhattanOrder.order.basket);
    const basketItemLoading = basketItems.find((item: IBasketOrderItem) => item.showFullSizeLoader === true);
    const itemId = basketItemLoading?.id;

    next(updateFullItemLoaderStatusAction({
      itemId,
      status: false
    }));
  }

}
